import $ from 'jquery'
$(document).ready(function() {
	if (!$('.team-member-list').length) {
		return
	}

	const $acModal = $('[data-remodal-id=tm-modal]').remodal({
		hashTracking: false
	})
	const imageContainer = $('#tm-modal-image')
	const metaContainer = $('#tm-modal-meta')
	const contentContainer = $('#tm-modal-content')

	$(document).on('click', '[data-modal-trigger="tm-modal"]', function(e) {
		e.preventDefault()

		imageContainer.css(
			'background-image',
			$(this)
				.find('.image-area')
				.css('background-image')
		)

		$(this)
			.find('h3,.subtitle1,.subtitle2')
			.clone()
			.appendTo(metaContainer)

		contentContainer.html(
			$(this)
				.find('.content-holder')
				.html()
		)

		$acModal.open()
	})

	$(document).on('closed', '.tm-modal', function() {
		imageContainer.html('')
		metaContainer.html('')
		contentContainer.html('')
	})
})
